import { toast } from "react-toastify";
import api from "./api";

// Korumalı /uploads dosyasını Authorization header'ı ile indirip yeni sekmede açar.
// Token'ı URL'e (?token=) koymak loglara, tarayıcı geçmişine ve Referer'a sızdırır.
export const openProtectedFile = async (url) => {
  // Sekmeyi tıklama anında aç; await sonrası açılan pencereler popup engelleyiciye takılır
  const newTab = window.open("", "_blank");
  try {
    const { data } = await api.get(url, { responseType: "blob" });
    const blobUrl = URL.createObjectURL(data);
    if (newTab) {
      newTab.location.href = blobUrl;
    } else {
      window.open(blobUrl, "_blank");
    }
    setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  } catch (error) {
    newTab?.close();
    toast.error(error?.response?.status === 403 ? "Bu belgeye erişim yetkiniz yok." : "Belge açılamadı.");
  }
};
